import { render, staticRenderFns } from "./Subordinate.vue?vue&type=template&id=1e24cdb4&scoped=true&"
import script from "./Subordinate.vue?vue&type=script&lang=js&"
export * from "./Subordinate.vue?vue&type=script&lang=js&"
import style0 from "./Subordinate.vue?vue&type=style&index=0&id=1e24cdb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e24cdb4",
  null
  
)

export default component.exports